import { defineMessages } from 'react-intl';

export default defineMessages({
    semiAnnualPayment: {
        id: 'ml.common.util.MLBillingUtil.Semi-annual payment',
        defaultMessage: 'Semi-annual payment'
    },
    annualPayment: {
        id: 'ml.common.util.MLBillingUtil.Annual payment',
        defaultMessage: 'Annual payment'
    },
    ratingPaymentMethodBankAccount: {
        id: 'ml.common.util.MLBillingUtil.bank_account',
        defaultMessage: 'Checking/savings account (autopay)'
    },
    ratingPaymentMethodCheck: {
        id: 'ml.common.util.MLBillingUtil.check',
        defaultMessage: 'Send a bill (pay online or by mail)'
    },
    ratingPaymentMethodCreditCard: {
        id: 'ml.common.util.MLBillingUtil.credit_debit_card',
        defaultMessage: 'Credit/debit card (autopay)'
    },
    ratingPaymentMethodMortgagee: {
        id: 'ml.common.util.MLBillingUtil.mortgagee',
        defaultMessage: 'Mortgage'
    },
    ratingPaymentMethodBankPayrollDeduction: {
        id: 'ml.common.util.MLBillingUtil.payroll_deduction',
        defaultMessage: 'Payroll deduction (autopay)'
    },
    ratingPaymentMethodBankPayrollDeductionQNB: {
        id: 'ml.common.util.MLBillingUtil.payroll_deduction_qnb',
        defaultMessage: 'Payroll deduction (autopay) — No down payment required'
    },
    ratingDownPaymentMethodCreditCard: {
        id: 'ml.common.util.MLBillingUtil.DownPayment.credit_debit_card',
        defaultMessage: 'Credit/debit card '
    },
    ratingDownPaymentMethodBankAccount: {
        id: 'ml.common.util.MLBillingUtil.DownPayment.bank_account',
        defaultMessage: 'Checking/savings account'
    },
    ratingDownPaymentMethodBankPayrollDeduction: {
        id: 'ml.common.util.MLBillingUtil.DownPayment.payroll_deduction',
        defaultMessage: 'Payroll deduction '
    },
    monthlyPayment: {
        id: 'ml.common.util.MLBillingUtil.Monthly payment',
        defaultMessage: 'Monthly payment'
    },
    twicePerMonth: {
        id: 'ml.common.util.MLBillingUtil.Twice per month',
        defaultMessage: 'Twice per month'
    },
    twoPay: {
        id: 'ml.common.util.MLBillingUtil.Two pay',
        defaultMessage: 'Two pay'
    },
    fourPay: {
        id: 'ml.common.util.MLBillingUtil.Four pay',
        defaultMessage: 'Four pay'
    },
    payrollDeduct: {
        id: 'ml.common.util.MLBillingUtil.Payroll deduct',
        defaultMessage: 'Payroll deduct'
    },
});